import React, { FC, useLayoutEffect } from 'react'
import { RootContainer } from '@root/RootContainer'
import styled from 'styled-components'
import { useAppSelector } from '@/hooks/reduxHooks'

const Wrapper = styled(RootContainer)<{ headerHeight: number }>`
  padding-top: calc(${({ headerHeight }) => headerHeight}px + 40px);
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const PrivacyPolicy: FC = () => {
  const headerHeight = useAppSelector(state => state.header.height)

  useLayoutEffect(() => {
    window.scroll(0, 0)
  }, [])

  return (
    <Wrapper headerHeight={headerHeight}>
      <h1>Политика конфиденциальности для интернет-магазина:</h1>

      <h2>1. Сбор и использование личных данных</h2>
      <p>
        Мы собираем имя и электронную почту пользователей, которые
        зарегистрировались на нашем сайте. Эти данные используются для создания
        учетной записи пользователя и обработки заказов. Мы также можем
        использовать электронную почту для отправки информации о новых продуктах
        и специальных предложениях, если пользователь выразил желание получать
        такую информацию.
      </p>

      <h2>2. Хранение и защита личных данных</h2>
      <p>
        Мы храним личные данные пользователей на нашем сервере и предпринимаем
        все необходимые меры для обеспечения их безопасности. Мы используем
        различные технологии и процедуры для защиты личных данных от
        несанкционированного доступа, использования, изменения и раскрытия.
      </p>

      <h2>3. Раскрытие личных данных третьим сторонам</h2>
      <p>
        Мы не раскрываем личные данные пользователей третьим сторонам без их
        согласия, за исключением случаев, предусмотренных законом или когда это
        необходимо для обработки заказа. Мы также можем раскрывать общую
        статистическую информацию о наших пользователях третьим сторонам для
        анализа рынка и статистических целей, но эта информация не будет
        содержать личных данных.
      </p>

      <h2>4. Отказ от получения рассылки</h2>
      <p>
        Пользователи, которые не хотят получать рассылку о новых продуктах и
        специальных предложениях, могут отказаться от этой услуги, нажав на
        соответствующую ссылку в электронной почте.
      </p>

      <p>5. Права пользователей</p>
      <p>
        Пользователи имеют право на доступ, исправление, удаление и ограничение
        использования своих личных данных. Они также могут запросить экспорт
        своих личных данных. Если пользователь хочет воспользоваться своими
        правами, он может обратиться к нам по адресу электронной почты,
        указанному на сайте.
      </p>

      <h2>6. Изменения политики конфиденциальности</h2>
      <p>
        Мы оставляем за собой право изменять эту политику конфиденциальности в
        любое время. Мы будем уведомлять пользователей об изменениях на сайте
        и/или по электронной почте. Если пользователь продолжает использовать
        наш сайт после внесения изменений в политику конфиденциальности, он
        соглашается с новыми условиями.
      </p>
    </Wrapper>
  )
}

export default PrivacyPolicy
